/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_New_Fox_EnterInputs */

const en_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the new email address for your account`)
};

const id_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan alamat email baru untuk akun Anda`)
};

const ms_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan alamat emel baharu untuk akaun anda`)
};

const ca_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introdueix la nova adreça de correu electrònic per al teu compte.`)
};

const cs_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte novou emailovou adresu pro váš účet`)
};

const da_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast den nye e-mailadresse til din konto`)
};

const de_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie die neue E-Mail-Adresse für Ihr Konto ein`)
};

const et_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisestage oma konto uus e-posti aadress`)
};

const es_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce la nueva dirección de correo electrónico para tu cuenta`)
};

const fr_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez votre nouvelle adresse e-mail`)
};

const hr_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unesite novu e-mail adresu za svoj račun.`)
};

const it_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il nuovo indirizzo email per il tuo account`)
};

const lv_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ievadiet jauno e-pasta adresi savam kontam.`)
};

const lt_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įveskite naują el. pašto adresą savo paskyrai`)
};

const hu_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adja meg az új email címet a fiókjához`)
};

const nl_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer het nieuwe e-mailadres voor je account in`)
};

const nb_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv inn den nye e-postadressen for kontoen din`)
};

const pl_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj nowy adres e-mail dla swojego konta`)
};

const pt_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite o novo endereço de e-mail para sua conta.`)
};

const ro_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduceți noua adresă de e-mail pentru contul dvs.`)
};

const sk_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadajte novú e-mailovú adresu vášho účtu`)
};

const sl_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vnesite nov e-poštni naslov za vaš račun`)
};

const fi_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä uusi sähköpostiosoite tilillesi.`)
};

const sv_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange den nya e-postadressen för ditt konto`)
};

const vi_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập địa chỉ email mới cho tài khoản của bạn`)
};

const tr_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınız için yeni e-posta adresini girin`)
};

const el_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εισάγετε τη νέα διεύθυνση email για τον λογαριασμό σας`)
};

const bg_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Въведете новия имейл адрес за вашия акаунт.`)
};

const ru_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите новый адрес электронной почты для вашего аккаунта.`)
};

const sr_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Унесите нову имејл адресу за ваш налог`)
};

const uk_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введіть нову адресу електронної пошти для вашого облікового запису`)
};

const ka_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეიყვანეთ ახალი მეილის მისამართი თქვენი ანგარიშისთვის.`)
};

const hi_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने खाते के लिए नया ईमेल पता दर्ज करें`)
};

const th_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้อนที่อยู่อีเมลใหม่สำหรับบัญชีของคุณ`)
};

const ko_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정의 새 이메일 주소를 입력하세요`)
};

const zh_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您账户的新电子邮件地址`)
};

const zh_tw_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請輸入您帳戶的新電子郵件地址`)
};

const ja_fresh_new_fox_enter = /** @type {(inputs: Fresh_New_Fox_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントの新しいメールアドレスを入力してください`)
};

/**
* | output |
* | --- |
* | "Enter the new email address for your account" |
*
* @param {Fresh_New_Fox_EnterInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const fresh_new_fox_enter = /** @type {((inputs?: Fresh_New_Fox_EnterInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_New_Fox_EnterInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fresh_new_fox_enter(inputs)
	if (locale === "ms") return ms_fresh_new_fox_enter(inputs)
	if (locale === "ca") return ca_fresh_new_fox_enter(inputs)
	if (locale === "cs") return cs_fresh_new_fox_enter(inputs)
	if (locale === "da") return da_fresh_new_fox_enter(inputs)
	if (locale === "de") return de_fresh_new_fox_enter(inputs)
	if (locale === "et") return et_fresh_new_fox_enter(inputs)
	if (locale === "es") return es_fresh_new_fox_enter(inputs)
	if (locale === "fr") return fr_fresh_new_fox_enter(inputs)
	if (locale === "hr") return hr_fresh_new_fox_enter(inputs)
	if (locale === "it") return it_fresh_new_fox_enter(inputs)
	if (locale === "lv") return lv_fresh_new_fox_enter(inputs)
	if (locale === "lt") return lt_fresh_new_fox_enter(inputs)
	if (locale === "hu") return hu_fresh_new_fox_enter(inputs)
	if (locale === "nl") return nl_fresh_new_fox_enter(inputs)
	if (locale === "nb") return nb_fresh_new_fox_enter(inputs)
	if (locale === "pl") return pl_fresh_new_fox_enter(inputs)
	if (locale === "pt") return pt_fresh_new_fox_enter(inputs)
	if (locale === "ro") return ro_fresh_new_fox_enter(inputs)
	if (locale === "sk") return sk_fresh_new_fox_enter(inputs)
	if (locale === "sl") return sl_fresh_new_fox_enter(inputs)
	if (locale === "fi") return fi_fresh_new_fox_enter(inputs)
	if (locale === "sv") return sv_fresh_new_fox_enter(inputs)
	if (locale === "vi") return vi_fresh_new_fox_enter(inputs)
	if (locale === "tr") return tr_fresh_new_fox_enter(inputs)
	if (locale === "el") return el_fresh_new_fox_enter(inputs)
	if (locale === "bg") return bg_fresh_new_fox_enter(inputs)
	if (locale === "ru") return ru_fresh_new_fox_enter(inputs)
	if (locale === "sr") return sr_fresh_new_fox_enter(inputs)
	if (locale === "uk") return uk_fresh_new_fox_enter(inputs)
	if (locale === "ka") return ka_fresh_new_fox_enter(inputs)
	if (locale === "hi") return hi_fresh_new_fox_enter(inputs)
	if (locale === "th") return th_fresh_new_fox_enter(inputs)
	if (locale === "ko") return ko_fresh_new_fox_enter(inputs)
	if (locale === "zh") return zh_fresh_new_fox_enter(inputs)
	if (locale === "zh-tw") return zh_tw_fresh_new_fox_enter(inputs)
	if (locale === "ja") return ja_fresh_new_fox_enter(inputs)
	return en_fresh_new_fox_enter(inputs)
});